// extracted by mini-css-extract-plugin
export default {"container":"style_container__a2V9E"};